// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-popup-feedback-form {
  display: flex;
  flex-direction: column;
}

.dialog-popup-feedback-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.dialog-popup-feedback-section-label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dialog-popup-feedback-section-title {
  font-size: var(--ui-font-md);
  font-weight: 600;
  color: #374151;
}

.dialog-popup-feedback-section-description {
  font-size: var(--ui-font-sm);
  color: #6b7280;
  line-height: 1.4;
}

.dialog-popup-feedback-textarea-container {
  position: relative;
}

.dialog-popup-feedback-textarea {
  width: calc(100% - 2rem);
  min-height: 100px;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: var(--ui-font-md);
  line-height: 1.5;
  color: #374151;
  background: #f8fafc;
  resize: vertical;
  transition: all 0.2s ease;
  font-family: inherit;
}

.dialog-popup-feedback-textarea:focus {
  outline: none;
  border-color: var(--tertiary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: var(--primary-bg);
}

.dialog-popup-feedback-textarea::placeholder {
  color: #9ca3af;
}

.dialog-popup-feedback-textarea-counter {
  position: absolute;
  bottom: 0.5rem;
  right: 0.75rem;
  font-size: var(--ui-font-sm);
  color: #9ca3af;
  background: white;
  padding: 0.25rem 0.5rem;
  border-radius: 15px;
  border: 1px solid #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/components/DialogPopup/DialogPopupFeedback/DialogPopupFeedback.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".dialog-popup-feedback-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.dialog-popup-feedback-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.dialog-popup-feedback-section-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dialog-popup-feedback-section-title {\n  font-size: var(--ui-font-md);\n  font-weight: 600;\n  color: #374151;\n}\n\n.dialog-popup-feedback-section-description {\n  font-size: var(--ui-font-sm);\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.dialog-popup-feedback-textarea-container {\n  position: relative;\n}\n\n.dialog-popup-feedback-textarea {\n  width: calc(100% - 2rem);\n  min-height: 100px;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: var(--ui-font-md);\n  line-height: 1.5;\n  color: #374151;\n  background: #f8fafc;\n  resize: vertical;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.dialog-popup-feedback-textarea:focus {\n  outline: none;\n  border-color: var(--tertiary-color);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background: var(--primary-bg);\n}\n\n.dialog-popup-feedback-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.dialog-popup-feedback-textarea-counter {\n  position: absolute;\n  bottom: 0.5rem;\n  right: 0.75rem;\n  font-size: var(--ui-font-sm);\n  color: #9ca3af;\n  background: white;\n  padding: 0.25rem 0.5rem;\n  border-radius: 15px;\n  border: 1px solid #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
